<template>
  <div>
    <el-dialog class="mt-2" width="600px" :visible.sync="isOpen" :append-to-body="true">
      <slot />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
  },
};
</script>
